import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "dashboard"
    }
  },
  {
    path: '/register',
    name: 'Register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ForgotPassword.vue')
  },
  {
    path: '/changepassword',
    name: 'ChangePassword',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ChangePassword.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "dashboard"
    }
  },
  {
    path: '/onboarding',
    name: 'DashboardOnboarding',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "dashboard",
      onboarding: true
    }
  },
  {
    path: '/account',
    name: 'Account',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Account.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "account"
    }
  },
  {
    path: '/account/defaults',
    name: 'AccountDefaults',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Account.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "formdefaults"
    }
  },
  {
    path: '/changelog',
    name: 'ChangeLog',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ChangeLog.vue')
  },
  {
    path: '/upcoming',
    name: 'Upcoming',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Upcoming.vue')
  },
  {
    path: '/faq',
    name: 'Faq',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Faq.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/upgrade',
    name: 'Upgrade',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Upgrade.vue')
  },
  {
    path: '/feedback-widget',
    name: 'WebRatingFeaturePage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/WebRatingFeaturePage.vue')
  },
  {
    path: '/account/create',
    name: 'AccountCreate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AccountCreate.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "dashboard"
    }
  },
  

  {
    path: '/walloflove',
    name: 'WallOfLove',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/WallOfLove.vue')
  },
  {
    path: '/yourwallsoflove',
    name: 'UserWallsOfLoveList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "wol" */ '../views/UserWallOfLoveList.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "walloflove"
    }
  },
  {
    path: '/yourwalloflove/:wolId',
    name: 'UserWallOfLoveEdit',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "wol" */ '../views/UserWallOfLoveEdit.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "walloflove"
    }
  },
  
  {
    path: '/feedback/create',
    name: 'FeedbackCreate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FeedbackCreate.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "newnlform",
      formType: "newsletter"
    }
  },
  {
    path: '/feedback/create/ot/:copyFormId?',
    name: 'OTFeedbackCreate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FeedbackCreate.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "newotform",
      formType: "onetime"
    }
  },
  {
    path: '/feedback/create/wr/:copyFormId?',
    name: 'WRFeedbackCreate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FeedbackCreate.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "newwrform",
      formType: "webrating"
    }
  },
  
  {
    path: '/feedback/:formId',
    name: 'FeedbackView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FeedbackView.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "allforms"
    }
  },
  {
    path: '/feedbacks',
    name: 'FeedbackList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FeedbackList.vue'),
    meta: {
      layout: 'AppLayoutAdmin',
      activeMenu: "allforms"
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
})

export default router
